import React, { Component, Children } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Chevron from '../../icons/Chevron'

/*
Expects an array of Card components that can populate `./ui-components/card-carousel/card.js` (see comments in that file for details)
*/

const throttle = func => {
  let cancel

  return function () {
    clearTimeout(cancel)
    cancel = setTimeout(func, 100, arguments)
  }
}

class Carousel extends Component {
  constructor (props) {
    super(props)
    this.state = {
      scroll: 0,
      viewport: 0,
      slider: 0,
      card: 0
    }

    this.resizeHandler = throttle(this.resizeHandler)
  }

  componentDidMount () {
    this.resizeHandler() // Set initial state after mount
    window.addEventListener('resize', this.resizeHandler, false)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.resizeHandler)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.children.length !== this.props.children.length) {
      this.resizeHandler()
    }
  }

  // Update buttons on resize
  resizeHandler = () => {
    const viewport = this.viewport.clientWidth // inside measurement
    const card = this.card.offsetWidth // outside measurement
    const slider = this.slider.scrollWidth // size needed for entire scroll pane
    this.setState({ viewport, card, slider })
  }

  // Update buttons on scroll
  scrollHandler = () => {
    const scroll = this.viewport.scrollLeft
    this.setState({ scroll })
  }

  // Scroll the viewport
  scroll = (e, direction) => {
    e.stopPropagation() // stop event from hitting something else below

    const { scroll, card } = this.state
    let left
    if (direction === 'left') {
      left = scroll - card
    } else {
      left = scroll + card
    }

    this.viewport.scroll({ top: 0, left, behavior: 'smooth' })
  }

  render () {
    const { children, className, withTheme, ...otherProps } = this.props

    const leftButton = this.state.scroll > 0
    const rightButton = this.state.scroll + this.state.viewport < this.state.slider

    return (
      <div className={classnames('carousel', className)} {...otherProps}>
        {leftButton &&
          <button
            aria-label='Scroll Left'
            onClick={e => this.scroll(e, 'left')}
            className={classnames(
              'carousel__button carousel__button--left',
              {'carousel__button carousel__button--themed': withTheme}
            )}>
            <span className='carousel__button-icon'>
              <Chevron direction='left' />
            </span>
          </button>}
        <div className='carousel__viewport' onScroll={this.scrollHandler} ref={(el) => { this.viewport = el }}>
          <div ref={(el) => { this.slider = el }} className='carousel__slider'>
            { Children.map(children, child => {
              return (
                <div ref={(el) => { this.card = el }} className='carousel__item-wrapper'>
                  <div className='carousel__item'>{child}</div>
                </div>
              )
            })}
          </div>
        </div>
        {rightButton &&
          <button
            aria-label='Scroll Right'
            onClick={e => this.scroll(e, 'right')}
            className={classnames(
              'carousel__button carousel__button--right',
              {'carousel__button carousel__button--themed': withTheme}
            )}>
            <span className='carousel__button-icon'>
              <Chevron direction='right' />
            </span>
          </button>}
      </div>
    )
  }
}

Carousel.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  withTheme: PropTypes.bool
}

Carousel.defaultProps = {
  withTheme: true
}

export default Carousel
